import { selectCartGroupOrderSlug } from 'bento-ordering/cart/selectors/index';

/**
 * Gets an object with the group_order field and its value.
 *
 * Note: This is intended to be use for an API action to obtain the group_order query param.
 *
 * @param {*} state the redux state object.
 * @returns either an empty object when there's not a group_order query param
 * or an object with the group_order field and its value.
 */
const getGroupOrderQueryParam = state => {
  const groupOrderQueryParam = selectCartGroupOrderSlug(state);

  return groupOrderQueryParam ? { group_order: groupOrderQueryParam } : {};
};

export default getGroupOrderQueryParam;
